jQuery(document).ready(function () {
	jQuery('.block-tabs .mobiletoggle').click(function (e) {
		e.preventDefault();
		jQuery(this).parent().toggleClass('open');
	});
	jQuery('.tabs__link').click(function () {
		jQuery(this).parent().removeClass('open');
		jQuery(this).parent().find('.mobiletoggle').html(jQuery(this).html());
	});
	jQuery('.tabs__link:eq(0)').click();
});
